import SignatureService from '@/services/SignatureService'

const state = {
  items: [],
  pageCount: 1,
  queryParams: {
    page: 1,
    limit: 50,
    sort: 'Objektnr',
    direction: 'desc'
  },
  loading: false,
  updating: false,
  needreload: true
}

const getters = {
  items: state => state.items,
  pageCount: state => state.pageCount,
  queryParams: state => state.queryParams,
  loading: state => !!state.loading,
  updating: state => !!state.updating,
  needreload: state => !!state.needreload || state.items.length < 1
}

const actions = {
  load: ({commit, dispatch}, kundenr) => {
    return new Promise((resolve, reject) => {
      commit('load')

      SignatureService.list(kundenr, state.queryParams)
        .then((response) => {
          let payload = {
            items: response.data,
            pageCount: response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1
          }

          commit('success', payload)
          resolve(response)
        })
        .catch((error) => {
          commit('failure')
          reject(error)
        })
    })
  },
  reload: ({commit, dispatch}, params) => {
    commit('reload', params.queryParams || null)
    dispatch('load', params.kundenr)
  },
  setNeedReload: ({commit, dispatch}) => {
    commit('setNeedReload')
  },
  removeItem: ({commit, dispatch}, Objektid) => {
    commit('removeItem', Objektid)
  }
}

const mutations = {
  load: (state) => {
    if (!state.updating) {
      state.loading = true
    }
  },
  reload: (state, payload) => {
    state.updating = true

    if (payload !== null) {
      state.queryParams = payload
    }
  },
  success: (state, payload) => {
    state.loading = false
    state.updating = false

    state.items = payload.items || []
    state.pageCount = payload.pageCount

    state.needreload = false
  },
  failure: (state) => {
    state.loading = false
    state.updating = false

    state.items = []
    state.pageCount = 1

    state.needreload = true
  },
  setNeedReload: (state) => {
    state.needreload = true
  },
  removeItem: (state, Objektid) => {
    if (state.items && state.items.length > 0) {
      const found = state.items.findIndex(i => i.Objektid === Objektid)

      if (found !== -1) {
        state.items.splice(found, 1)
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/kundeobjektsignature.js